import { useState } from "react";
import { Link } from "react-router-dom";
import { Mail } from "lucide-react";
import api, { fmtErr } from "../../lib/api";
import { Button } from "../../components/ui/button";
import { Input } from "../../components/ui/input";
import { Label } from "../../components/ui/label";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await api.post("/auth/forgot-password", { email });
      setSent(true);
    } catch (err) {
      setError(fmtErr(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="max-w-md mx-auto px-4 py-14">
      <div className="bg-white rounded-2xl border border-[#BFE8E9] p-8 shadow-sm animate-rise">
        <h1 className="font-display font-bold text-xl mb-2">Reset your password</h1>
        {sent ? (
          <div className="text-sm text-slate-600" data-testid="forgot-sent-msg">
            <p>If that email is registered, a reset link has been sent. Check your inbox — the link expires in 1 hour.</p>
          </div>
        ) : (
          <form onSubmit={submit} className="space-y-4">
            <p className="text-sm text-slate-500">Enter your account email and we'll send you a reset link.</p>
            <div>
              <Label>Email</Label>
              <Input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} data-testid="forgot-email" />
            </div>
            {error && <p className="text-sm text-red-600" data-testid="forgot-error">{error}</p>}
            <Button type="submit" className="w-full bg-[#0E7C84] hover:bg-[#093F46]" disabled={loading} data-testid="forgot-submit-btn">
              <Mail className="w-4 h-4 mr-2" /> {loading ? "Sending…" : "Send reset link"}
            </Button>
          </form>
        )}
        <p className="mt-4 text-sm text-center">
          <Link to="/login" className="text-[#0E7C84] hover:underline" data-testid="back-to-login">Back to sign in</Link>
        </p>
      </div>
    </div>
  );
}
